import {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import useDebounce from '../../../../../utilities/hooks/useDebounce/useDebounce';
import FloatingSearchBox from '../../../../../components/mazraeKit/floatingSearchBox';
import useGeAddressByTitleSearch from '../../../../../services/hookService/getLocationByTitleSearch/useGeAddressByTitleSearch';
import DotsLoading from '../../../../../components/dotsLoading';

const SaleAgentSearchingLocation = () => {
  const {
    state: {searchBarAddress, assigner_store},
  } = useLocation();

  const [inputValue, setInputValue] = useState<string>(searchBarAddress);
  const debouncedValue = useDebounce(inputValue, 2000);
  const navigate = useNavigate();

  useEffect(() => {
    setInputValue(searchBarAddress);
  }, [searchBarAddress]);

  const {address, isLoading} = useGeAddressByTitleSearch(debouncedValue);

  const handleClickAfterSelect = (item: ILocationByTitleSearch) => {
    navigate(`/sale-agent-location-by-map/${assigner_store}`, {
      state: {location: item, assigner_store: assigner_store},
    });
  };

  return (
    <div className="w-full h-full px-3">
      <div className="flex justify-between h-14 items-center  border-b border-gray-200">
        <span>آدرس فروشگاه </span>
        <i
          className="icon-nameClose-remove text-xl font-Bold"
          onClick={() => navigate(-1)}
        />
      </div>
      <FloatingSearchBox
        label="جستجوی آدرس"
        type="text"
        value={inputValue}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setInputValue(e.target.value)
        }
        {...{inputValue, setInputValue}}
        isAutofcus={true}
      />
      {isLoading ? (
        <div className=" flex justify-center items-center h-full">
          <DotsLoading />
        </div>
      ) : (
        <>
          {address &&
            [...address?.state, ...address?.city].map(item => (
              <div
                className="border-b-2 p-3"
                onClick={() => handleClickAfterSelect(item)}
              >
                {<span>{item.name}</span>}
              </div>
            ))}
        </>
      )}
    </div>
  );
};

export default SaleAgentSearchingLocation;
